// NOTICE: KAPTION-INTEGRATION
// RUMO Widget Studio launch URL. One Studio deployment (studio.rumohq.com)
// serves every RUMO origin, so the launch fragment names this dashboard's origin
// as `api`; Studio only uses it when it is on Studio's own allowlist
// (rumo-sdk-studio.AUTH-4). The fragment keeps the one-use token out of logs.
export const KAPTION_RUMO_STUDIO_DEFAULT_URL = 'http://localhost:4173';

export const kaptionRumoStudioFrameUrl = (
  launchToken,
  { surface, studioUrl = import.meta.env.VITE_RUMO_STUDIO_URL } = {}
) => {
  const base = (studioUrl || KAPTION_RUMO_STUDIO_DEFAULT_URL).replace(
    /\/+$/,
    ''
  );
  const query = surface
    ? `?embedded=1&surface=${encodeURIComponent(surface)}`
    : '?embedded=1';
  const fragment = `launch_token=${encodeURIComponent(launchToken)}&api=${encodeURIComponent(window.location.origin)}`;
  return `${base}/${query}#${fragment}`;
};
